'use client';
import { ReactNode } from 'react';

import { TabsContent, Tabs as TabsCore, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface Tab {
  key: string;
  label: ReactNode;
  children: ReactNode;
}
interface ITabProps {
  items: Tab[];
  onChange?: (key: string) => void;
  value?: string;
}
export const Tabs = ({ items, onChange, value }: ITabProps) => {
  return (
    <TabsCore defaultValue={items[0].key} value={value} onValueChange={onChange}>
      <TabsList className="flex items-center divide-x divide-gray-100 p-0">
        {items?.map((item) => {
          return (
            <TabsTrigger
              key={item.key}
              value={item.key}
              className={
                'data-[state=active]:text-orange-500 data-[state=active]:bg-orange-50 data-[state=active]:shadow-none rounded-none flex-1 bg-gray-50 text-center text-gray-500 h-[44px] leading-[44px] cursor-pointer'
              }
            >
              {item.label}
            </TabsTrigger>
          );
        })}
      </TabsList>
      <div className="pt-[20px]">
        {items?.map((item) => {
          return (
            <TabsContent key={item.key} value={item.key}>
              {item.children}
            </TabsContent>
          );
        })}
      </div>
    </TabsCore>
  );
};
